import { render } from "./TatCrossedCases.vue?vue&type=template&id=66d236d5"
import script from "./TatCrossedCases.vue?vue&type=script&lang=js"
export * from "./TatCrossedCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/TatCrossedCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66d236d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66d236d5', __exports__)) {
    console.log('reload')
    api.reload('66d236d5', __exports__)
  }
  
  module.hot.accept("./TatCrossedCases.vue?vue&type=template&id=66d236d5", () => {
    console.log('re-render')
    api.rerender('66d236d5', render)
  })

}


export default __exports__